import React from 'react'

const Select = ({ name, options, value, onChange, width, disabled }) => {
  return (
    <select
      className={`${width || 'w-full'} border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white disabled:bg-gray-50 disabled:text-gray-500`}
      value={value}
      onChange={onChange}
      disabled={disabled}
    >
      <option value=''>Select {name}</option>
      {options.map((item) => (
        <option key={item.id} value={item.id}>{item.title}</option>
      ))}
    </select>
  )
}

export default Select
